import { onReady } from "../../utils/events/onReady";
import { addEvent } from "../../utils/events/events";

export class CarLoan {
    data = {};
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} container - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;

        onReady(() => this.init(this.dom.container));
    }


    openPopup(e) {
        if(e.target.classList.contains("info__icon--popup")) {
            const parent = e.target.parentNode;
            const popup = parent.children[2];
            const popups = this.dom.container.querySelectorAll(".result-container__popup.visible");
            if(popups.length > 0) {
                popups.forEach(popup => {
                    popup.classList.remove("visible");
                })
            } else {
                popup.classList.toggle("visible")
            }
        }
    }

    submitLoan(e) {
        e.preventDefault();
        if(window.matchMedia("(max-width: 992px)").matches) {
            document.querySelector(".right__column#result").scrollIntoView({behavior: "smooth"});
        }
        const overlay = this.dom.container.querySelector(".overlay__right--column");
        overlay.classList.add("visible");
        const popups = document.querySelectorAll('.result-container__popup.visible').forEach(popup => {
            popup.classList.remove("visible");
        })
        setTimeout(() => {
            const price = parseFloat(this.dom.container.querySelector("#cal-price").value);
            const terms = parseFloat(this.dom.container.querySelector("#cal-terms").value);
            const payout = parseFloat(this.dom.container.querySelector("#cal-payout").value);
            let termsPerYear = 12;
            let interestAdditionsPerYear = 4;
            let termsPerInterestAddition = termsPerYear/interestAdditionsPerYear;
            let interestAdditions = terms/termsPerInterestAddition;
            let loan = price - payout;
            let payoutShare = payout / price;
            const checkboxValue = this.dom.container.querySelector(".checkbox__description input[type=checkbox]").getAttribute("aria-checked");	// Is member of Købstædernes Forsikring
            let member = checkboxValue === "true" ? true : false;
            let sp = (member ? 3500 : 5000);							// Stiftelsesprovision
            let fTg = 1750;												// Fast tinglysningsgebyr
            let fd = 950;												// Finansieringsdeklaration
            let totalBefore = sp + fTg + fd;							// Samlet før variabel tinglysningsafgift
            let vTg = ((totalBefore+loan)/0.985-(totalBefore+loan));
            vTg = Math.ceil(vTg/100)*100;								// Rund op til nærmeste hele 100
            let initialCosts = totalBefore + vTg;
            let principal = loan + initialCosts;
            let interestRate = (payoutShare < 0.2 ? 0.0495 : 0.0315);
            let interestRatePerTerm = interestRate/interestAdditionsPerYear;
            let newInteresRate = Math.pow((1+interestRatePerTerm), 1/termsPerInterestAddition) - 1;
            let monthlyPayment = this.monthlyPaymentFormula(principal, terms, newInteresRate);
            document.querySelector("#cal-principal").textContent = ( this.numberSeparator(principal) );
            document.querySelector("#cal-monthly-payment").textContent = ( this.numberSeparator(Math.round(monthlyPayment)) );
            document.querySelector("#cal-floating-rate").textContent = ( parseFloat(interestRate*100).toFixed(2) );
            document.querySelector("#cal-initial-costs").textContent =  ( this.numberSeparator((initialCosts.toFixed(0))) );
            overlay.classList.remove("visible");
        } , 1000);
    }

     numberSeparator(number) {
        if (isNaN(number)) {
            return '';
        }
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

     monthlyPaymentFormula(p, n, i) {
        return p * i / (1 - Math.pow(1+i, -n));
    }

    toggleCheckbox(e) {
        let ariaValue = JSON.parse(e.target.getAttribute("aria-checked"));
        e.target.setAttribute("aria-checked", !ariaValue);
    }

    init() {
        const infoIcon = this.dom.container.querySelectorAll(".result-container__title .info__icon--popup");
        infoIcon.forEach(icon => {
            addEvent(icon, "click", (e) => {this.openPopup(e)})
        })
        const buttonSubmit = this.dom.container.querySelector(".button.submit__loan");
        addEvent(buttonSubmit, "click", (e) => {this.submitLoan(e)})


        const checkBoxDiscount = this.dom.container.querySelector(".checkbox__description input[type=checkbox]");
        addEvent(checkBoxDiscount, "click", (e) => this.toggleCheckbox(e))
    }
}
